import { mergeStyles } from "@fluentui/react";
import { commonStyles, containerStyles, designTokens, sectionStyles, } from "./shared.styles";
export const recentOutagesSectionStyles = {
    // Re-export shared styles for easy access
    sectionHeader: sectionStyles.header,
    sectionHeaderComplete: sectionStyles.headerComplete,
    incidentTilesContainer: containerStyles.incidentTilesContainer,
    // Component-specific styles (using common styles)
    sectionContainer: commonStyles.sectionContainer,
    emptyState: commonStyles.emptyState,
    outageInfo: commonStyles.outageInfo,
    actionsContainer: commonStyles.submitButtonContainer,
    fieldLabel: mergeStyles({
        fontWeight: 600,
    }),
    requiredIndicator: mergeStyles({
        color: "#d13438",
    }),
    optionalIndicator: mergeStyles({
        color: designTokens.colors.textSecondary,
        fontWeight: 400,
    }),
    supportRequestsContainer: mergeStyles({
        marginTop: designTokens.spacing.sm,
    }),
};
